import React from "react";
import { Link } from "react-router-dom";


const SolutionsIllustration: React.FC = () => (
  <svg viewBox="0 0 320 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%", display: "block" }}>
    {/* Background */}
    <rect width="320" height="200" fill="url(#sol_bg)" rx="10"/>

    {/* Card 1 — eKYC / Face */}
    <rect x="16" y="16" width="130" height="76" rx="8" fill="rgba(255,255,255,0.10)" stroke="rgba(255,255,255,0.18)" strokeWidth="1"/>
    {/* Face circle */}
    <circle cx="44" cy="44" r="14" fill="rgba(0,200,150,0.25)" stroke="#00c896" strokeWidth="1.5"/>
    <circle cx="44" cy="40" r="5" fill="rgba(255,255,255,0.7)"/>
    <path d="M34 56c0-5.5 4.5-10 10-10s10 4.5 10 10" stroke="rgba(255,255,255,0.7)" strokeWidth="1.4" strokeLinecap="round"/>
    {/* Scan lines */}
    <line x1="30" y1="44" x2="58" y2="44" stroke="#00c896" strokeWidth="0.8" strokeDasharray="2 2"/>
    {/* Labels */}
    <rect x="64" y="33" width="60" height="6" rx="3" fill="rgba(255,255,255,0.5)"/>
    <rect x="64" y="44" width="42" height="4" rx="2" fill="rgba(255,255,255,0.3)"/>
    <rect x="16" y="72" width="130" height="4" rx="0" fill="rgba(0,200,150,0.4)"/>
    {/* Score pill */}
    <rect x="64" y="54" width="36" height="12" rx="6" fill="#00c896"/>
    <rect x="68" y="58" width="28" height="4" rx="2" fill="rgba(255,255,255,0.8)"/>

    {/* Card 2 — Watchlist */}
    <rect x="16" y="104" width="130" height="76" rx="8" fill="rgba(255,255,255,0.10)" stroke="rgba(255,255,255,0.18)" strokeWidth="1"/>
    <rect x="24" y="114" width="72" height="5" rx="2.5" fill="rgba(255,255,255,0.5)"/>
    {/* Row items */}
    {[0,1,2].map((i) => (
      <g key={i}>
        <rect x="24" y={128+i*14} width="8" height="8" rx="4" fill={i===0?"#ef4444":i===1?"#f59e0b":"#00c896"} opacity="0.8"/>
        <rect x="36" y={130+i*14} width="56" height="4" rx="2" fill="rgba(255,255,255,0.4)"/>
        <rect x="100" y={128+i*14} width="30" height="8" rx="4" fill={i===0?"rgba(239,68,68,0.25)":i===1?"rgba(245,158,11,0.25)":"rgba(0,200,150,0.25)"} stroke={i===0?"#ef4444":i===1?"#f59e0b":"#00c896"} strokeWidth="0.8"/>
      </g>
    ))}

    {/* Card 3 — Compliance Score */}
    <rect x="158" y="16" width="146" height="164" rx="8" fill="rgba(255,255,255,0.10)" stroke="rgba(255,255,255,0.18)" strokeWidth="1"/>
    <rect x="168" y="26" width="88" height="6" rx="3" fill="rgba(255,255,255,0.5)"/>
    <rect x="168" y="36" width="60" height="4" rx="2" fill="rgba(255,255,255,0.25)"/>

    {/* Donut chart */}
    <circle cx="231" cy="88" r="32" stroke="rgba(255,255,255,0.1)" strokeWidth="10"/>
    <circle cx="231" cy="88" r="32" stroke="#00c896" strokeWidth="10"
      strokeDasharray="183 18" strokeLinecap="round"
      transform="rotate(-90 231 88)"/>
    <text x="231" y="93" textAnchor="middle" fill="white" fontSize="14" fontWeight="700" fontFamily="sans-serif">97%</text>

    {/* Stat rows */}
    {[
      { label: "PEP Checked", ok: true },
      { label: "Sanctions", ok: true },
      { label: "Liveness", ok: true },
      { label: "Doc Auth", ok: true },
    ].map((item, i) => (
      <g key={i}>
        <rect x="168" y={134+i*14} width="90" height="4" rx="2" fill="rgba(255,255,255,0.35)"/>
        <circle cx="284" cy={136+i*14} r="5" fill="#00c896" opacity="0.9"/>
        <path d={`M281 ${136+i*14}l2.5 2.5 4-4`} stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    ))}

    {/* Defs */}
    <defs>
      <linearGradient id="sol_bg" x1="0" y1="0" x2="320" y2="200" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0f2040"/>
        <stop offset="1" stopColor="#1a3560"/>
      </linearGradient>
    </defs>
  </svg>
);

const ArrowSVG = ({ size = 25 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6.29297" y="21.4106" width="22.36" height="2.83936" transform="rotate(-40.2798 6.29297 21.4106)" fill="white" />
    <rect x="9.44922" y="7.56982" width="2.83936" height="2.83936" transform="rotate(-40.2798 9.44922 7.56982)" fill="white" />
    <rect x="13.4492" y="7.89941" width="2.83936" height="2.83936" transform="rotate(-40.2798 13.4492 7.89941)" fill="white" />
    <rect x="17.4492" y="8.23047" width="2.83936" height="2.83936" transform="rotate(-40.2798 17.4492 8.23047)" fill="white" />
    <rect x="21.1211" y="12.562" width="2.83936" height="2.83936" transform="rotate(-40.2798 21.1211 12.562)" fill="white" />
    <rect x="20.7969" y="16.5645" width="2.83936" height="2.83936" transform="rotate(-40.2798 20.7969 16.5645)" fill="white" />
    <rect x="20.4648" y="20.5664" width="2.83936" height="2.83936" transform="rotate(-40.2798 20.4648 20.5664)" fill="white" />
  </svg>
);

const MegaMenuServices: React.FC = () => {
  return (
    <ul className="submenu">
      <li>
        <div className="mega_menu_wrapper">
          <div className="container-fluid p-0">
            <div className="mega_menu_wrapper_inner megamenu_widget_wrapper">
              <div className="row justify-content-lg-between">
                {/* ---------- Left Main Column ---------- */}
                <div className="col-xl-9 col-lg-8">
                  <div className="mega_menu_box">
                    <div className="megamenu_widget_inner">
                      <div className="row">
                        {/* Column 1 */}
                        <div className="col-xl-4 col-lg-6 megamenu-col">
                          <div className="megamenu_widget">
                            <ul className="icon_list unordered_list_block">
                              {[
                                "Fintech & Lending.",
                                "Banking & Insurance.",
                                "Telco & Marketplace.",
                                "E-commerce & Retail.",
                              ].map((text, index) => (
                                <li key={index}>
                                  <Link to="/about">
                                    <span className="icon_list_text">{text}</span>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        {/* Column 2 */}
                        <div className="col-xl-8 col-lg-6 megamenu-col">
                          <div className="megamenu_widget">
                            <ul className="icon_list unordered_list_block">
                              {[
                                "Government & Public Services.",
                                "Healthcare & Clinics.",
                                "Crypto & Web3.",
                                "HR & Workforce.",
                              ].map((text, index) => (
                                <li key={index}>
                                  <Link to="/about">
                                    <span className="icon_list_text">{text}</span>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Social + Service Link */}
                    <div className="social_area">
                      <div className="row mt-none-30 align-items-center">
                        <div className="col-xl-4 mt-30">
                          <div className="social_inner ul_li">
                            <span>Follow Us:</span>
                            <ul className="social_icons_list unordered_list">
                              <li>
                                <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer">
                                  <i className="fab fa-linkedin-in"></i>
                                </a>
                              </li>
                              <li>
                                <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.6774 7.62177L17.2342 0H15.6805L9.98719 6.61788L5.43998 0H0.195312L7.07159 10.0074L0.195312 18H1.74916L7.76141 11.0113L12.5636 18H17.8083L10.677 7.62177H10.6774ZM8.54921 10.0956L7.8525 9.09906L2.30903 1.16971H4.69564L9.16929 7.56895L9.866 8.56546L15.6812 16.8835H13.2946L8.54921 10.096V10.0956Z" fill="#FFF" />
                                  </svg>
                                </a>
                              </li>
                              <li>
                                <a href="https://github.com/" target="_blank" rel="noopener noreferrer">
                                  <i className="fab fa-github"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                {/* ---------- Right Image Column ---------- */}
                <div className="col-xl-3 col-lg-4">
                  <div className="megamenu_case">
                    <div className="xb-item--inner">
                      <div className="xb-item--img" style={{ borderRadius: "8px", overflow: "hidden", lineHeight: 0 }}>
                        <SolutionsIllustration />
                      </div>
                      <div className="xb-item--holder">
                        <h3 className="xb-item--title">Identity verification for every industry.</h3>
                        <p className="xb-item--text">
                          Purpose-built compliance and onboarding flows that
                          fit your regulatory requirements.
                        </p>
                        <Link className="thm-btn agency-btn megamenu-btn" to="/about">
                          <span className="text">explore solutions</span>
                          <span className="arrow">
                            <span className="arrow-icon">
                              <ArrowSVG size={25} />
                              <ArrowSVG size={25} />
                            </span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default MegaMenuServices;
